import { observable, action, makeObservable, computed } from "mobx";
import { Fields } from "./Fields";
import validateLoginData from "../../logic/ValidationChecks/LoginDataValidation";
import { ValidationError } from "./ValidationError";

export interface ILoginFields {
    username: string;
    password: string;
}

export class LoginData extends Fields<ILoginFields, LoginData> implements ILoginFields {
    @observable username = "";
    @observable password = "";
    @observable error?: string;

    constructor() {
        super();

        makeObservable(this);
    }

    /***** Setters *****/

    @action setUsername(username: string) {
        this.username = username;
    }

    @action setPassword(password: string) {
        this.password = password;
    }

    @action setError(error: string | undefined) {
        this.error = error;
    }

    /***** Computed properties *****/

    @computed get validationErrors(): ValidationError<LoginData>[] {
        return validateLoginData({
            ...this,
            username: this.username.trim()
        });
    }

    serialize() {
        return {
            username: this.username.trim(),
            password: this.password
        }
    }
}